import classnames from 'classnames';
import PropTypes from 'prop-types';
import { Component, createRef } from 'react';

import Button from 'shared/components/button/Button';
import ExternalLink from 'shared/components/ExternalLink';
import ShareEmail from 'shared/components/icon/ShareEmail';
import ShareFb from 'shared/components/icon/ShareFb';
import ShareTwitter from 'shared/components/icon/ShareTwitter';
import Sentry from 'shared/utils/sentry';
import { getText } from 'shared/utils/Text';
import { getUrl, withDefault } from 'shared/utils/urls';

import styles from './index.module.scss';

export default class UrlSharer extends Component {
  constructor(props) {
    super(props);
    this.inputNode = createRef();
  }

  static propTypes = {
    url: PropTypes.string,
    mailBody: PropTypes.string,
    isPdf: PropTypes.bool,
    pdfLinkText: PropTypes.string,
  };

  static defaultProps = {
    isPdf: false,
  };

  state = {
    copied: false,
  };

  componentWillUnmount() {
    window.clearTimeout(this.timerId);
  }

  onCopyClick = async () => {
    window.clearTimeout(this.timerId);
    const { url } = this.props;

    if (this.inputNode.current) {
      this.inputNode.current.select();
    }

    try {
      await navigator.clipboard.writeText(url);

      this.setState({ copied: true });
      this.timerId = window.setTimeout(
        () => this.setState({ copied: false }),
        8000,
      );
    } catch (error) {
      Sentry.captureException(error);
      if (process.env.NODE_ENV === 'development') {
        console.error(error);
      }
    }
  };

  render() {
    const { url, mailBody, isPdf, pdfLinkText } = this.props;
    const { copied } = this.state;

    return (
      <div
        className={classnames(styles.urlSharer, {
          [styles.loading]: !url,
        })}
      >
        {isPdf && (
          <div className={styles.pdfWrapper}>
            {/* eslint-disable-next-line react/jsx-no-target-blank */}
            <a href={withDefault(url)} target="_blank">
              <span className="sprite dialog-confirm" />
              <span className={styles.label}>
                {getText(pdfLinkText || 'urlsharer-pdf')}
              </span>
            </a>
          </div>
        )}

        <ul
          className={classnames(
            'fgrid fgrid--1of4 fgrid--center',
            styles.buttonList,
          )}
        >
          <li className={classnames('fgrid-cell', styles.header)}>
            {getText('urlsharer-header')}
          </li>

          <li className="fgrid-cell">
            <ExternalLink url={getUrl.shareFb(url)}>
              <ShareFb className={styles.icon} />
            </ExternalLink>
          </li>

          <li className="fgrid-cell">
            <ExternalLink url={getUrl.shareTw(url)}>
              <ShareTwitter className={styles.icon} />
            </ExternalLink>
          </li>
          <li className="fgrid-cell">
            <ExternalLink
              url={`mailto:?subject=Jokersystemet&body=${withDefault(
                mailBody,
              )}`}
            >
              <ShareEmail className={styles.icon} />
            </ExternalLink>
          </li>
        </ul>

        <hr />

        <div className="relative">
          <input
            ref={this.inputNode}
            type="url"
            value={withDefault(url)}
            readOnly
          />
          <Button className={styles.btnCopy} onClick={this.onCopyClick}>
            {getText('urlsharer-copy-button')}
          </Button>
          <span
            className={classnames(styles.btnFeedback, {
              [styles.visible]: copied,
            })}
          >
            {getText('urlsharer-copy-feedback')}
          </span>
        </div>
      </div>
    );
  }
}
